export const formatTimeWithTimezone = (dateString) => {
  if (!dateString) return 'TBD';
  
  try {
    const date = new Date(dateString);
    
    const timeFormatter = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York'
    });
    
    const timeString = timeFormatter.format(date);
    
    return `${timeString} EST`;
  } catch (e) {
    console.error('Format time with timezone error:', e);
    return new Date(dateString).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }
};

export const formatDateEST = (dateString) => {
  if (!dateString) return 'TBD';
  
  try {
    const date = new Date(dateString);
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'America/New_York'
    });
    
    return dateFormatter.format(date);
  } catch (e) {
    console.error('Format date error:', e);
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }
};

export const formatDateTimeEST = (dateString) => {
  if (!dateString) return 'TBD';
  
  try {
    const date = new Date(dateString);
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York'
    });
    
    const dateTimeString = dateFormatter.format(date);
    return `${dateTimeString} EST`;
  } catch (e) {
    console.error('Format date time error:', e);
    return new Date(dateString).toLocaleString('en-US');
  }
};
